import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../layouts/page";
import { config } from "../../../config";
import Submit from "../../../components/button";

import FormField from "../../../components/formfield";
import SelectField from "../../../components/selectfield";
import useFetch from "../../../helpers/fetch";
import Backbtn from "../../../components/backbtn";

const EditEMRotator = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    estate_id: "",
    name: "",
    service_category_id: "",
    service_sub_category_id: "",
    position: "",
    telephone_number: "",
    whatsapp_number: "",
    address: "",
    visibility: "Private",
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetching data for the service provider
  const { data: rotator, loading: loadingRotator } = useFetch(
    `${config.api_path}/rotators/${id}`,
    0
  );


  useEffect(() => {
    if (rotator) {
      console.log(rotator);
      setFormData({
        estate_id: rotator?.data?.estate?.id,
        name: rotator?.data?.name,
        service_category_id: rotator?.data?.service_sub_category?.category_id,
        service_sub_category_id: rotator?.data?.service_sub_category?.id,
        position: rotator?.data?.position,
        telephone_number: rotator?.data?.telephone_number,
        whatsapp_number: rotator?.data?.whatsapp_number,
        address: rotator?.data?.address,
        visibility: rotator?.data?.visibility,
      });
    }
  }, [rotator, id]);
  // Fetching data
  const { data: estates = [], loading: loadingEstates } = useFetch(
    `${config.api_path}/estates`,
    0
  );

  const { data: categories = [], loading: loadingCategories } =
    useFetch(
      `${config.api_path}/service-categories?all=true&importance=Urgent`,
      0
    );
  const { data: subCategories = [], loading: loadingSubCategories } =
    useFetch(
      formData?.service_category_id
        ? `${config.api_path}/service-sub-categories?category_id=${formData.service_category_id}&all=true`
        : null,
      0
    );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("auth_token");
    const formDataToSubmit = { ...formData };

    // Ensure estate_id is included if visibility is Private
    if (formDataToSubmit.visibility === "Private" && !formDataToSubmit.estate_id) {
      toast.error("Estate is required for Private visibility.");
      setLoading(false);
      return;
    }

    // Ensure required fields are not empty
    if (!formDataToSubmit.name || !formDataToSubmit.telephone_number || !formDataToSubmit.service_sub_category_id) {
      toast.error("All required fields must be filled.");
      setLoading(false);
      return;
    }

    try {
      await axios.put(
        `${config.api_path}/rotators/${id}`,
        formDataToSubmit, // Send as JSON
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Emergency rotator updated successfully!");
      setTimeout(() => {
        navigate(-1);
      }, 1000);
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <h3>Edit Emergency Rotator</h3>
            <Backbtn />
            <form onSubmit={handleSubmit}>
              <div className="row">
                <section className="col-md-12">
                  <div className="row">
                    <FormField
                      width="col-md-6"
                      label="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                    <FormField
                      width="col-md-6"
                      label="Telephone Number"
                      name="telephone_number"
                      value={formData.telephone_number}
                      onChange={handleInputChange}
                      required
                    />
                    <FormField
                      width="col-md-6"
                      label="Whatsapp Number"
                      name="whatsapp_number"
                      value={formData.whatsapp_number}
                      onChange={handleInputChange}
                    />
                    <FormField
                      width="col-md-6"
                      label="Position"
                      name="position"
                      value={formData.position}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="row">
                    <SelectField
                      width="col-md-6"
                      label="Visibility Status"
                      name="visibility"
                      value={formData.visibility}
                      onChange={handleInputChange}
                      options={[
                        { id: "Public", name: "Public" },
                        { id: "Private", name: "Private" },
                      ]}
                      required
                    />
                    {formData.visibility === "Private" && (
                      <SelectField
                        width="col-md-6"
                        label="Estate"
                        name="estate_id"
                        value={formData.estate_id}
                        onChange={handleInputChange}
                        options={estates?.data}
                        loading={loadingEstates}
                        required
                      />
                    )}
                    <SelectField
                      width="col-md-6"
                      label="Service Category"
                      name="service_category_id"
                      value={formData.service_category_id}
                      onChange={handleInputChange}
                      options={categories?.data}
                      loading={loadingCategories}
                      required
                    />
                    <SelectField
                      width="col-md-6"
                      label="Service Sub category"
                      name="service_sub_category_id"
                      value={formData.service_sub_category_id}
                      onChange={handleInputChange}
                      options={subCategories?.data}
                      loading={loadingSubCategories}
                      required
                      disabled={!formData?.service_category_id}
                    />
                    <FormField
                      width="col-md-6"
                      label="Address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                    />
                  </div>

                </section>

              </div>
              <div className="row">
                <div className="col-md-12">
                  <Submit loading={loading} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Layout>
  );
};

export default EditEMRotator;
